<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="字典名称">
              <a-input placeholder="请输入" v-model="queryParams.dictName"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="字典类型">
              <a-input placeholder="请输入" v-model="queryParams.dictType"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="状态">
              <a-radio-group button-style="solid" v-model="queryParams.status">
                <a-radio-button
                  v-for="dict in statusOptions"
                  :key="dict.dictValue"
                  :value="dict.dictValue">
                  {{ dict.dictLabel }}
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="24" v-if="advanced">
            <a-form-item label="创建时间">
              <a-range-picker @change="rangePicker" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['system:dict:add']" >新增</a-button>
      <a-button @click="handleDeleteBatch(selectedRowKeys)" v-hasPermi="['system:dict:remove']" :disabled="selectedRowKeys.length === 0">删除</a-button>
      <a-button @click="handleExport()" v-hasPermi="['system:dict:export']" >导出</a-button>
      <a-button @click="handleClearCache()" v-hasPermi="['system:dict:remove']" >清理缓存</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="dictId"
          :scroll="{ fixScreen: true, x: 1300 }"
          @selectedRowChange="selectedRowChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.DICT_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="action" slot-scope="{ record }">
            <a @click="$refs.createModal.show(record)" v-hasPermi="['system:dict:edit']">编辑</a>
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">
                更多 <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a href="javascript:;" @click="handleDelete(record)" v-hasPermi="['system:dict:remove']">删除</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
          <span slot="status" slot-scope="{ record }">
            {{ statusFormat(record) }}
          </span>
          <span slot="dictType" slot-scope="{ record }">
            <router-link :to="'/dict/type/data/' + record.dictId" class="link-type">
              <span>{{ record.dictType }}</span>
            </router-link>
          </span>
        </ls-api-table>
        <!-- 底部分页按钮 -->
        <!-- 创建/编辑字典,单独封装了组件 -->
        <create-form
          ref="createModal"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { delType, listType, clearCache } from '@/api/system/dict/type'
import CreateForm from './components/CreateForm'
import SubDataTable from './components/subDataTable'
import { generateLsTableResData } from '@/utils/util.js';

export default {
  name: 'Dict',
  components: {
    CreateForm,
    SubDataTable
  },
  data () {
    return {
             // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(listType, true),
        pageCurrent: true
      },
       // 分页数据(默认第一页):
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      pageSize: 10,
      total: 0,
      // 控制搜索展开
      advanced: true,
      // 日期选择
      dateRange: [],
      // 查询参数
      queryParams: {
        current: 1,
        pageSize: 10,
        dictName: undefined,
        dictType: undefined,
        status: undefined
      },
      // 状态字典
      statusOptions: [],
      // 字典表格数据
      typeList: [],
      tableLoading: false,
      // 表格字段
      columns: [
        {
          title: '字典编号',
          dataIndex: 'dictId',
          align: 'center',
          width: 100
        },
        {
          title: '字典名称',
          dataIndex: 'dictName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '字典类型',
          dataIndex: 'dictType',
          ellipsis: true,
          scopedSlots: { customRender: 'dictType' },
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '操作',
          width: 140,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      }
    }
  },
  created () {
   // this.getList()
    this.getDicts('sys_normal_disable').then(response => {
      this.statusOptions = response.data
    })
  },
   mounted () {
    this.onSearch();
  },
  methods: {
            /** 行选中 */
     selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
      },
        // 表单搜索
     onSearch () {
      this.$refs.dataTable.searchParams = this.addDateRange(this.queryParams, this.dateRange)
      this.$refs.dataTable.getData();
    },
    /** 查询字典类型列表 */
    getList () {
      this.tableLoading = true
      listType(this.addDateRange(this.queryParams, this.dateRange)).then(response => {
          this.typeList = response.rows
          this.total = response.total
          this.tableLoading = false
        }
      )
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // 字典状态字典翻译
    statusFormat (row, column) {
      return this.selectDictLabel(this.statusOptions, row.status)
    },
    // 搜索框中的日期选择
    rangePicker (date, dateString) {
      this.dateRange = dateString
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.current = 1
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.dateRange = []
      this.queryParams = {
        current: 1,
        pageSize: 10,
        dictName: undefined,
        dictType: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      const dictId = row.dictId
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 字典编号为${dictId}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delType(dictId).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    /** 批量删除按钮操作 */
    handleDeleteBatch (ids) {
      const dictIds = ids
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 字典编号为${dictIds}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delType(dictIds).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('system/dict/type/export', {
        ...this.queryParams
      }, `type_${new Date().getTime()}.xlsx`)
    },
    /** 清理缓存按钮操作 */
    handleClearCache () {
      clearCache().then(response => {
        this.$message.success('清除成功!')
      })
    }

  }
}
</script>
